import { withUnmountTransition } from '../../../../../misc/withUnmountTransition.hoc'
import { InsiPatientFirstnameChangeValidationModal } from './InsiPatientFirstnameChangeValidationModal.component'

const withUnmountHoc = withUnmountTransition(InsiPatientFirstnameChangeValidationModal)
export { withUnmountHoc as InsiPatientFirstnameChangeValidationModal }
